import moment from "moment";

export default class AdditionalFieldOptionContent {
    id;
    language;

    label;
    content;
    image;

    static fromJson = (json) => {
        let content = new AdditionalFieldOptionContent();

        content.id = json.id;
        content.language = json.language;

        content.label = json.label;
        content.content = json.content;
        content.image = json.image;


        content.updated_at = json.updated_at ? moment(json.updated_at) : null;
        content.updated_by = json.updated_by;

        return content;
    }
}